import { useAuth } from './useAuth';
import { useUserProfile } from './useUserProfile';

export function useRequirePlan() {
  const { user } = useAuth();
  const { tenant, userRoles, isLoading } = useUserProfile();
  
  // Super admins não precisam de plano
  const isSuperAdmin = userRoles?.some(role => role.role === 'super_admin');
  
  // Verifica se requer seleção de plano
  // Usuário TEM roles/tenant criados mas NÃO tem plano selecionado
  const requiresPlanSelection = 
    !isLoading && 
    user && 
    !isSuperAdmin &&
    userRoles && 
    userRoles.length > 0 && // TEM roles (tenant já foi criado pela trigger)
    tenant && 
    !tenant.subscription_plan_id; // MAS ainda não selecionou o plano
  
  return {
    requiresPlanSelection,
    tenant,
    isLoading // Não incluir userRoles no loading state pois array vazio é válido
  };
}
